// @context TGW-2926 Mac の日本語入力で全角「５００」と打つと、半角に変換する前に金額欄が 0 に書き換わり、
//   500円のチケットしか作れなかった。チケット設定のモーダルを実際に描いて、金額欄の動きを確かめる。
import React from 'react';
import ReactDOM from 'react-dom';
import { act } from 'react-dom/test-utils';
import { PlanDetailsSettingModal } from './section_plans';

jest.mock('../axios', () => ({ post: jest.fn(() => Promise.resolve({ data: {} })) }));

const basePlan = {
  id: 1,
  name: '通常チケット',
  price_type: 3,
  creator_price: 1500,
  price: 1500,
  description: '',
};

let container;
let latestPlan;

const Harness = ({ initialPlan }) => {
  const [eventsPlan, setEventsPlan] = React.useState(initialPlan);
  latestPlan = eventsPlan;
  return (
    <PlanDetailsSettingModal
      closeModal={() => {}}
      eventsPlan={eventsPlan}
      setEventsPlan={setEventsPlan}
      isCompanyOwnedCircle={false}
      reservationSystemFee={0}
      isEditable
      updateEventsPlan={() => {}}
      tunagateFeeRate={0.1}
    />
  );
};

const priceInput = () => container.querySelector('#creator_price');

// React 17 の onChange は input イベント、onBlur は focusout を拾う
const typeInto = (input, value) => {
  const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
  act(() => {
    setter.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });
};
const blur = (input) => {
  act(() => {
    input.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
  });
};

beforeEach(() => {
  window.innerWidth = 375; // 日時ピッカー（jQuery）の初期化を通らない幅にする
  container = document.createElement('div');
  document.body.appendChild(container);
  act(() => {
    ReactDOM.render(<Harness initialPlan={basePlan} />, container);
  });
});

afterEach(() => {
  ReactDOM.unmountComponentAtNode(container);
  container.remove();
});

describe('チケット金額欄（TGW-2926）', () => {
  it('全角で打った文字が 0 に書き換わらず、そのまま残る', () => {
    typeInto(priceInput(), '５００');
    expect(priceInput().value).toBe('５００');
  });

  it('全角のまま欄を離れても、半角の金額として確定する', () => {
    typeInto(priceInput(), '２０００');
    blur(priceInput());
    expect(priceInput().value).toBe('2000');
    expect(latestPlan.creator_price).toBe(2000);
    expect(latestPlan.price).toBe(2000);
    expect(latestPlan.price_type).toBe(3);
  });

  it('全部消しても 0 が表示されない', () => {
    typeInto(priceInput(), '');
    expect(priceInput().value).toBe('');
  });

  it('数字以外は打てるが、欄を離れると理由を出して直前の金額に戻す', () => {
    typeInto(priceInput(), 'abc');
    expect(priceInput().value).toBe('abc');
    blur(priceInput());
    expect(priceInput().value).toBe('1500');
    expect(latestPlan.creator_price).toBe(1500);
    expect(container.textContent).toContain('金額は数字で入力してください');
  });

  it('500円未満で離れると理由を出して直前の金額に戻す', () => {
    typeInto(priceInput(), '300');
    blur(priceInput());
    expect(priceInput().value).toBe('1500');
    expect(latestPlan.creator_price).toBe(1500);
    expect(container.textContent).toContain('500円以上で入力してください');
  });

  it('エラー文は読み上げソフトに伝わる要素（role="alert"）で出す', () => {
    typeInto(priceInput(), 'abc');
    blur(priceInput());
    const alert = container.querySelector('[role="alert"]');
    expect(alert).not.toBeNull();
    expect(alert.textContent).toBe('金額は数字で入力してください');
  });

  it('打ち直すとエラー表示が消える', () => {
    typeInto(priceInput(), 'abc');
    blur(priceInput());
    typeInto(priceInput(), '3');
    expect(container.textContent).not.toContain('金額は数字で入力してください');
  });
});
